import { Button, Table, Input, Row, Col, Modal, Radio, message, Typography, Flex, Select, Card } from "antd";
import { DeleteOutlined, EditOutlined, PlusCircleOutlined, SearchOutlined } from "@ant-design/icons";
import Highlighter from 'react-highlight-words';
import { useEffect, useRef, useState, } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../API";
import dayjs from 'dayjs';

function CampaignList({cmpType}) {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user'));
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [filterDataByRadioBtn, setFilterDataByRadioBtn] = useState('All');
  const [searchText, setSearchText] = useState('');
  const [options, setOptions] = useState(null);
  const [selectedOAId, setselectedOAId] = useState(null);
  const [relativeData, setRelativeData] = useState({
    originalCampaigns: [],
    originalIdsSegVsCont: [],
    originalSegments: [],
    originalContacts: [],
    originalTemplates: [],
    originalOAAccounts: [],
    originalZaloGroups: [],
  })
  const dataOnTable = useRef([]);
  const columns = [
    {
      title: "ID",
      dataIndex: "key",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    {
      title: "Name",
      width: '16%',
      dataIndex: "campaignName",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    {
      title: "Template Id",
      width: '10%',
      dataIndex: "templateId",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    {
      title: "Created Date",
      dataIndex: "createDate",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    {
      title: "Started At",
      dataIndex: "startedAt",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    {
      title: "Completed At",
      dataIndex: "completedat",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    {
      title: "Volume",
      dataIndex: "msgVolume",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    {
      title: 'Action',
      key: 'action',
      width: 105,
      align: 'center',
      render: (_, record) => (
        <Flex justify="space-around" align="center">
            <Button 
              type="primary"  
              icon={<EditOutlined/>} 
              onClick={() => {
                  navigate(`/send/${cmpType}s/edit`,{
                    state: [
                      relativeData.originalCampaigns.find(obj => obj.campaignId === record.key),
                      relativeData.originalContacts,
                      relativeData.originalSegments,
                      relativeData.originalIdsSegVsCont,
                      relativeData.originalTemplates,
                      relativeData.originalOAAccounts,
                      relativeData.originalZaloGroups
                  ]})
              }}>
            </Button>
            <Button type="primary" danger 
                    icon={<DeleteOutlined/>}
                    onClick={() => {
                    Modal.confirm({
                        title: 'Confirm deletion',
                        content: 'Are you sure you want to delete this campaign?',
                        onOk() {handleRemoveRow(record.key)},
                        maskClosable: true
                    })
                    }}>
            </Button>
        </Flex>),
    }
  ];

  useEffect(() => {
    setLoading(true);
    Promise.all([
      api.list_all_contacts(user?.userId), 
      api.list_all_segments(user?.userId), 
      api.list_all_segmentsAndCotacts(),
      api.list_oaaccounts_by_user(user?.userId, user?.parentId,["id", "accountName","OAId"]),
      api.list_all_zalogroups(user?.userId)
    ])
    .then((results) => {
      setRelativeData(prevObj => ({
        ...prevObj,
        originalContacts: results[0].map(({id: key, zaloUid, phone, OAId, accountId, display_name})=>({ key, zaloUid, phone, OAId, accountId, display_name})),
        originalSegments: results[1],
        originalIdsSegVsCont: results[2],
        originalOAAccounts: results[3],
        originalZaloGroups: results[4].map(({id: key, ...obj})=>({ key, ...obj}))
      }))
      setOptions(results[3].map(oaacount => ({
        value: oaacount.OAId,
        label: oaacount.accountName
      })))
    })
    .catch((err) => message.error(err.message))
    .finally(() => setLoading(false))
  },[])

  useEffect(() => {
    Promise.all([
      api.list_all_campaigns(user?.userId),
      api.list_all_templates(cmpType === "gmfconsultant"? 'consultant': cmpType, user?.userId)
    ])
    .then(([campaigns, templates]) => {
      setRelativeData(prevObj => ({
        ...prevObj,
        originalCampaigns: campaigns,
        originalTemplates: templates
      })); 
      dataOnTable.current = campaigns.reduce((prevArr, {OAId ,campaignId, campaignName, startDate, templateId, startTime,createDate, template_type, msgVolume, isProcessed}) => {
        if(template_type === cmpType) {
          return [
            ...prevArr,
            {
              OAId,
              key: campaignId,
              campaignName,
              templateId,
              createDate: dayjs(createDate).format("YYYY-MM-DD"),
              startedAt: dayjs(dayjs(startDate).format("YYYY-MM-DD") + startTime).format("YYYY-MM-DD HH:mm:ss A"),
              completedat: null,
              status: isProcessed,
              msgVolume,
          }]}
        return prevArr;
      }, []);
      setDataSource(dataOnTable.current);
    })
  }, [cmpType]);

  function handleSelectedOAId(OAId) {
    let newCampaigns = dataOnTable.current;
    if(OAId) newCampaigns = newCampaigns.filter(value => value.OAId === OAId);
    if(filterDataByRadioBtn !== 'All') newCampaigns = newCampaigns.filter(value => value.status === filterDataByRadioBtn);
    if(searchText) newCampaigns = newCampaigns.filter((o) => Object.keys(o).slice(1).some((k) => o[k] && String(o[k])
      .toLowerCase()
      .includes(searchText.toLowerCase())));
    setLoading(true);
    setselectedOAId(OAId);
    setDataSource(newCampaigns);
    setLoading(false);
  }

  function handleFilterDataByRadioBtn(e) {
    let newCampaigns = dataOnTable.current;
    if(selectedOAId) newCampaigns = newCampaigns.filter(value => value.OAId === selectedOAId);
    if(e.target.value !== 'All') newCampaigns = newCampaigns.filter(value => value.status === e.target.value);
    if(searchText) newCampaigns = newCampaigns.filter((o) => Object.keys(o).slice(1).some((k) => o[k] && String(o[k])
      .toLowerCase()
      .includes(searchText.toLowerCase())));
    setLoading(true);
    setDataSource(newCampaigns);
    setFilterDataByRadioBtn(e.target.value);
    setLoading(false);
  }

  function handleSearchInfo(e) {
    let newCampaigns = dataOnTable.current;    
    if(selectedOAId) newCampaigns = newCampaigns.filter(value => value.OAId === selectedOAId);
    if(filterDataByRadioBtn !== 'All') newCampaigns = newCampaigns.filter(value => value.status === filterDataByRadioBtn);
    if(e.target.value) newCampaigns = newCampaigns.filter((o) => Object.keys(o).slice(1).some((k) => o[k] && String(o[k])
      .toLowerCase()
      .includes(e.target.value.toLowerCase())));
    setLoading(true);
    setDataSource(newCampaigns);
    setSearchText(e.target.value);
    setLoading(false);
  }

  async function handleRemoveRow(removeKey) {
    try {
      setLoading(true);
      await api.delete_message_byCmpId(removeKey);
      const response = await api.delete_campaign_byId(removeKey);
      message.success(response.message);
      dataOnTable.current = dataOnTable.current.filter(record => record.key !== removeKey);
      setRelativeData(prevObj => ({
        ...prevObj,
        originalCampaigns: prevObj.originalCampaigns.filter(record => record.campaignId !== removeKey)
      }))
      setDataSource(dataOnTable.current);
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Card 
        style={{height: '100%', margin: "0 auto", boxShadow: "1px 1px 5px #ccc", borderRadius: 10 }}
        title={
          <Typography.Title level={5} style={{margin: 0}}>{cmpType === 'gmfconsultants'? 'GMF Consultant': cmpType.charAt(0).toUpperCase() + cmpType.slice(1)}  Broadcast</Typography.Title>
        }
        loading={loading}
        extra={ 
          <Button 
            type="primary" 
            style={{padding:15}}
            icon={<PlusCircleOutlined/>}
            onClick={() => navigate(`/send/${cmpType}s/new`,
              {
                state: [
                  null,
                  relativeData.originalContacts,
                  relativeData.originalSegments,
                  relativeData.originalIdsSegVsCont,
                  relativeData.originalTemplates,
                  relativeData.originalOAAccounts,
                  relativeData.originalZaloGroups
                ]
              })}
            >New Campaign</Button>
        }
    >
      <Row gutter={[16,16]}  align="middle">
        <Col xxl={8} xl={8} lg={24} md={24} sm={24} xs={24}>
          <Select 
            style={{width:'100%'}}
            placeholder="Select OA Id"
            popupMatchSelectWidth={false}
            allowClear
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            onChange={handleSelectedOAId}
            options={options}
          />
        </Col>
        <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
          <Radio.Group defaultValue='All' onChange={handleFilterDataByRadioBtn}> 
            <Radio.Button value='All' >All</Radio.Button>
            <Radio.Button value='Active' >Active</Radio.Button>
            <Radio.Button value='Completed' >Completed</Radio.Button>
            <Radio.Button value='Open' >Open</Radio.Button>
          </Radio.Group>
        </Col>
        <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
          <Input 
              placeholder="Input search text"
              allowClear
              onChange={handleSearchInfo}
              suffix={<SearchOutlined />}/>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Table  
            bordered
            scroll={{x: 1000}}
            columns= {columns} 
            style={{marginTop: 16, width: '100%'}} 
            dataSource={dataSource}
            loading={loading}
            pagination={{
              position: ["bottomCenter"],
              showSizeChanger: false, // Disable page size changer
              pageSize: 10, 
              showTotal: () => `Total: ${dataSource.length} items`
            }}
          />
        </Col>
      </Row>
    </Card>
  )
}

export default CampaignList;